import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import type { Widget } from '../shared/types';
import type {
	GetPagedWidgetTimelineRequestParams,
	GetPagedWidgetTimelineResponse,
} from './types';

export const getPagedWidgetTimeline = async <T = Widget>({
	isApp = false,
	page,
	pageSize,
	lang,
}: GetPagedWidgetTimelineRequestParams): Promise<
	AxiosResponse<GetPagedWidgetTimelineResponse<T>>
> => {
	const params: Record<string, string | number> = {
		page,
		pageSize,
	};
	if (isApp) {
		params.channel = 'App';
	}
	if (lang) {
		params.lang = lang;
	}

	return api.get<GetPagedWidgetTimelineResponse<T>>('/cityzens/widgets', {
		params,
	});
};
